var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirstRank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 34,
    viewBox: "0 0 24 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0501 0H2.94991C1.35476 0 0 1.33839 0 3.06881V30.9116C0.00469403 33.108 2.5834 34.1385 4.04944 32.5968L10.9487 25.4215C11.5016 24.8214 12.4984 24.8214 13.0513 25.4215L19.9506 32.5968C21.4172 34.1391 23.9956 33.107 24 30.9116V3.06881C24 1.33839 22.6452 0 21.0501 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9193 18.064V19.3334H7.7513V18.064H10.6166V8.94537C10.6166 8.6716 10.626 8.39471 10.6446 8.11471L8.26464 10.1587C8.18375 10.2272 8.10286 10.2707 8.02197 10.2894C7.94108 10.3018 7.86641 10.3018 7.79797 10.2894C7.72952 10.2769 7.66419 10.252 7.60197 10.2147C7.54597 10.1774 7.50241 10.1369 7.4713 10.0934L6.94864 9.37471L10.934 5.93071H12.2873V18.064H14.9193Z",
    fill: "#F0A538"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstRank);
export default __webpack_public_path__ + "static/media/FirstRank.a37b899a0d601a3f6121aee763eb8ca4.svg";
export { ForwardRef as ReactComponent };